export class PagePaths {
  public static paths = {
    home: '',
    resume: 'resume',
    portfolio: 'portfolio',
    inquiries: 'inquiries',
    linkDirector: 'link-director',
    logo: 'logo',
    testingEnvironment: 'testing',
  };
}

/** The paths that actually have a route (everything else falls through to 404). */
export const ROUTE_PATHS = [
  PagePaths.paths.home,
  PagePaths.paths.resume,
  PagePaths.paths.portfolio,
  PagePaths.paths.inquiries,
  PagePaths.paths.logo,
  PagePaths.paths.testingEnvironment,
] as const;

/**
 * Which particle palette a given (basename-relative) pathname should render.
 * `constellation` = the green mesh used on the testing sandbox and the 404 page;
 * everything else uses the site accent ramp.
 */
export function paletteForPath(pathname: string): 'accent' | 'constellation' {
  const path = pathname.replace(/^\/+/, '');
  if (path === PagePaths.paths.testingEnvironment) return 'constellation';
  const isKnownRoute = (ROUTE_PATHS as readonly string[]).includes(path);
  return isKnownRoute ? 'accent' : 'constellation';
}
